// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselStyles } from "@steiner/Overrides/Widgets/Common/ProductCarousel";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCarouselStyles.titleText = {
    variant: "h2",
};

productCarouselStyles.carouselSlidesContainer = {
    css: css`
        .swiper-slide {
            max-width: 317px;
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }

            ${xScreen("gt", "sm")} {
                &:not(:last-child) {
                    & > .product-grid-container {
                        border-right: 1px solid ${color("common.border")};
                        padding-right: 24px;
                    }
                }
            }
        }
    `,
};
